export default {"src":"/_next/static/media/check-circle-green.ac5dcce1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};